/* eslint no-underscore-dangle: 0 */
import $ from 'jquery';

import GoogleDrive from '../schemas/GoogleDriveSchema';

const MAX_RESULTS = 10;
const MEDIA_TYPE = 'application/json';
const GOOGLEDRIVE_SEARCH = 'https://www.googleapis.com/drive/v3/files?includeItemsFromAllDrives=true&supportsAllDrives=true';

const GoogleDriveSearch = (token) => (searchQuery, maxResults = MAX_RESULTS, mimeType = null) => new Promise((resolve, reject) => {
    const beforeSend = (xhr) => {
        xhr.setRequestHeader('Authorization', `Bearer ${token}`);
        xhr.setRequestHeader('Accept', MEDIA_TYPE);
    };
    let query = `name contains '${searchQuery}' and trashed = false`;
    if (mimeType) {
        query += ` and mimeType = '${mimeType}'`;
    }
    const fields = 'files(id, name, mimeType, webViewLink, iconLink, createdTime, modifiedTime)';
    const url = window.encodeURI(`${GOOGLEDRIVE_SEARCH}&q=${query}&fields=${fields}&pageSize=${maxResults}`);

    window._tettraGoogleDriveSearchStore = window._tettraGoogleDriveSearchStore || {};

    if (searchQuery in window._tettraGoogleDriveSearchStore) {
        return resolve(window._tettraGoogleDriveSearchStore[searchQuery]);
    }

    return $.ajax({ url, beforeSend })
        .then(({ files }) => {
            const resources = files.map((file) => (new GoogleDrive(file)));
            window._tettraGoogleDriveSearchStore[searchQuery] = resources;
            resolve(resources);
        })
        .catch(reject);
});

const GoogleDriveFileInfo = (token) => (fileId) => {
    const GOOGLEDRIVE_FILE_URL = `https://www.googleapis.com/drive/v3/files/${fileId}`;
    const beforeSend = (xhr) => {
        xhr.setRequestHeader('Authorization', `Bearer ${token}`);
        xhr.setRequestHeader('Accept', MEDIA_TYPE);
    };
    const url = window.encodeURI(GOOGLEDRIVE_FILE_URL);

    return $.ajax({ url, beforeSend });
};

export { GoogleDriveSearch, GoogleDriveFileInfo };
